export function getThemeFromURL(hostname) {
  const parts = hostname.split(".");

  // Assuming your domain structure is [subdomain].[domain].[TLD]
  if (parts.length >= 3 && parts[0] !== "www") {
    // If there's a subdomain and it's not 'www', we consider it
    const subdomain = parts[0];

    switch (subdomain.toLowerCase()) {
      case "pulse":
        return "pulse";
      default:
        return "base";
    }
  } else {
    // No subdomain or 'www', return your default theme
    return "base";
  }
}
